module.exports = __webpack_public_path__ + "static/media/5x5no3-min.9b99ed73.jpg";